import { graphql } from 'src/graphql';

export const SaveSessionPages = graphql(`
  mutation SaveCalendarSessionPages($bookingId: ID!, $sessionId: ID!, $pages: BookingInputConfigSessionPages!) {
    updateBookingSessionPages(bookingId: $bookingId, sessionId: $sessionId, pages: $pages) {
      before {
        url
        title
        description
      }
      after {
        url
        title
        description
      }
    }
  }
`);
